export default "__VITE_ASSET__KpNI120$__"